module.exports = __webpack_public_path__ + "img/newspartinfo.a5ad3ee3.svg";